import React from 'react';
import { Box, styled } from '@mui/material';

const StyledMainContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  overflow: 'hidden',
  backgroundColor: theme.palette.background.default,
}));

const MainContainer = ({ children, ...props }) => {
  return (
    <StyledMainContainer {...props}>
      {children}
    </StyledMainContainer>
  );
};

export default MainContainer;